import React from "react";
import { Alert, Button } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import { useCurrentEmployee } from "../contexts/useCurrentEmployee";
import { initiateGoogleOAuth } from "@services/google/googleOauth";
import { LAYOUT_TOKENS } from "@ds/tokens/tokens";

export const GoogleScopeBanner: React.FC = () => {
  const { googleScopesOk } = useCurrentEmployee();

  if (googleScopesOk !== false) return null;

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: LAYOUT_TOKENS.spacingDefault }}
      message="Wymagana autoryzacja Google"
      description="Aplikacja potrzebuje dostępu do Dysku Google, Dokumentów, Gmaila i Arkuszy. Kliknij poniżej, aby udzielić uprawnień."
      action={
        <Button icon={<GoogleOutlined />} onClick={() => initiateGoogleOAuth()}>
          Autoryzuj Google
        </Button>
      }
    />
  );
};
